import React from 'react';
// import Select from 'react-select';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import { bindActionCreators } from 'redux';
import { injectIntl, intlShape } from 'react-intl';

import withStyles from 'isomorphic-style-loader/lib/withStyles';

// import * as formActions from 'shared/actions/searchForm';
// import { Button } from 'shared/components/UI';
import { SubscribeSearch, MoneyIcon } from 'shared/components/Icons';
import { Select, NumberInputWithSelect } from 'shared/components/UI';
import currencies from 'shared/constants/json/currency.json';
import { injectTopMakesToOptions } from 'shared/components/SearchPanel/transformOptions';

// import NumberInputQuestion from 'desktop/components/AdvertForm/NumberInputQuestion/NumberInputQuestion';

// import { InputText } from 'shared/components/AdvertFormV2/TextInputQuestionV2/I';

import s from './LeasingCarForm.css';

const isMobile = __APP__ === 'mobile';
const sluggifiedCurrency = currencies.map(item => ({ ...item, id: item.slug }));

class LeasingCarForm extends React.Component {
  static propTypes = {
    // brands: PropTypes.shape().isRequired,
    formState: PropTypes.shape().isRequired,
    formData: PropTypes.shape().isRequired,
    formVocabulary: PropTypes.shape().isRequired,
    selectedActions: PropTypes.shape({
      set: PropTypes.shape(),
    }).isRequired, // functions
    //
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    routeLocation: null,
  };

  state = {
    collapsed: true,
    selectedCurrency: null,
  };

  render() {
    const { intl, formState, formData, formVocabulary, selectedActions } = this.props;
    const { models } = formData;
    const { makes } = formVocabulary;
    const makesWithTopMakes = injectTopMakesToOptions(makes, intl);
    const selectedSetActions = selectedActions.set;
    const rootClass = isMobile ? s.rootMobile : s.root;
    return (
      <div className={rootClass}>
        <div className={s.column}>
          <div className={`${s.row} ${s.inputsBlock}`}>
            <Select
              placeholder={intl.formatMessage({ id: 'Марка' })}
              instanceId="make-ff"
              name="make"
              options={makesWithTopMakes}
              labelKey="title"
              valueKey="id"
              onChange={selectedSetActions.make}
              value={formState.make}
              matchPos="start"
            />
            <Select
              instanceId="model-ff"
              name="model"
              placeholder={intl.formatMessage({ id: 'Модель' })}
              labelKey="title"
              valueKey="id"
              disabled={!models || !models.length}
              options={models}
              onChange={selectedSetActions.model}
              value={formState.model}
              matchPos="start"
            />
            <NumberInputWithSelect
              placeholder={intl.formatMessage({ id: 'Ежемесячный платеж' })}
              name="monthly"
              Icon={MoneyIcon}
              value={formState.monthly}
              onChange={selectedSetActions.monthly}
              unitsSwitchOptions={sluggifiedCurrency}
              unitsSwitchValue={formState.currency || sluggifiedCurrency[0]}
              onUnitsChange={selectedSetActions.currency}
              titleKey="symbol"
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ globals }) => ({
  locale: globals.locale,
  location: globals.location,
});

export default withStyles(s)(connect(mapStateToProps)(injectIntl(LeasingCarForm)));



// WEBPACK FOOTER //
// ./src/desktop/components/SearchPanelV2/LeasingCarForm/LeasingCarForm.js